module.exports = __webpack_public_path__ + "img/22_newModelWorker_zr.7d198842.png";